import { Injectable, inject } from '@angular/core';
import { ConsumerEntityService } from '../../../consumer/services/consumer.entity.service';
import { EntityService } from '../../../core/services/entity.service';
import { GenericEntityStateClass, createEntityState } from '../../../core/state/entity.state';
import { SubjectEntityService } from '../../../subject/services/subject.entity.service';
import { ExerciseEntity } from '../exercise.entity';

export const STATE_NAME = 'exerciseEntity';

export const ExerciseEntityState: GenericEntityStateClass<ExerciseEntity> =
  createEntityState<ExerciseEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class ExerciseEntityService extends EntityService<ExerciseEntity> {
  private consumerEntityService = inject(ConsumerEntityService);
  private subjectEntityService = inject(SubjectEntityService);
  constructor() {
    super();
    this.resourceType = 'exercises';
    this.stateClass = ExerciseEntityState;

    this.registerRelation('consumers', this.consumerEntityService);
    this.registerRelation('subjects', this.subjectEntityService);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): ExerciseEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
